var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("notification.userStatusChanged", {
            name: _vm.$_.get(_vm.activity, "payload.name"),
            oldStatus: _vm.$_.get(_vm.activity, "payload.oldStatus"),
            newStatus: _vm.$_.get(_vm.activity, "payload.newStatus"),
          })
        ),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }